import { render, staticRenderFns } from "./ModalInfo.vue?vue&type=template&id=316fd8af&scoped=true&"
import script from "./ModalInfo.vue?vue&type=script&lang=js&"
export * from "./ModalInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalInfo.vue?vue&type=style&index=0&id=316fd8af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316fd8af",
  null
  
)

export default component.exports